import {environment} from '../../environments/environment';

export interface OrganizationProfileImageSource {
    profile_pic_url?: string | null;
    profile_pic?: string | null;
}

export function getApiOrigin(): string {
    try {
        return new URL(environment.baseUrl).origin;
    } catch {
        return '';
    }
}

export function resolveOrganizationProfilePicUrl(
    source?: OrganizationProfileImageSource | null
): string | null {
    const url = source?.profile_pic_url || source?.profile_pic || null;
    if (!url) {
        return null;
    }
    if (url.startsWith('data:') || url.startsWith('http://') || url.startsWith('https://')) {
        return url;
    }
    if (url.startsWith('/')) {
        const origin = getApiOrigin();
        return origin ? `${origin}${url}` : url;
    }
    return url;
}

export function getOrganizationInitials(name?: string | null): string {
    if (!name) {
        return 'OR';
    }
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (!parts.length) {
        return 'OR';
    }
    if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase();
    }
    return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
}
